import api from 'api'

export interface IDc4ReportPreviewResponse {
  count: number
  canGenerate: boolean
}

export const previewDc4Report = async (from: string, to: string) => {
  const response = await api.post<IDc4ReportPreviewResponse>(
    '/administration/dc4_reports/preview',
    { from, to }
  )
  return response.data
}

export const enqueueDc4Report = async (from: string, to: string) => {
  await api.post('/administration/dc4_reports', { from, to })
}
